import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

export const adminHolidayService = {
  getHolidays: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/template/holidays`, getAxiosOptions(user))).data
  },
  addHolidays: async (user, data) => {
    return (await axios.post(`${NODE_BASE_URL}/admin/holiday`, data, getAxiosOptions(user))).data
  },
}
